// configureStore.js
import { configureStore } from "@reduxjs/toolkit";
import globalReducer from "./globalReducer";
import leftMenuReducer from "./components/LeftMenu/reducer";
import customBillingReducer from "./components/Billing/reducer";

export const store = configureStore({
  reducer: {
    globalReducer: globalReducer,
    leftMenuReducer: leftMenuReducer,
    customBillingReducer: customBillingReducer,
  },
});
